import { FormControl } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Form, Formik } from 'formik'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'

import { getCancelReasons } from 'api'
import ModalForm from 'app/components/ModalForm'
import constants from 'app/constants'
import { eventEmitter } from 'app/helpers'

import CancelForm from './CancelForm'

const useStyles = makeStyles((theme) => ({
  formControl: {
    '& > *': {
      margin: theme.spacing(1)
    }
  }
}))

const CancelModal = (props) => {
  const classes = useStyles()
  const formRef = React.useRef(null)

  const {
    isModalOpen,
    closeModal,
    onSaveClick,
    action,
    cancelActionType = 'cancel',
    requireAlfredReason = false
  } = props

  const [formData] = React.useState({
    reason: '',
    notes: '',
    ...(requireAlfredReason ? { reason_for_using_alfred: '' } : null)
  })

  const [reasons, setReasons] = React.useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const reasonList = await getCancelReasons()
        if (Array.isArray(reasonList)) {
          reasonList.push('Other')
          setReasons(reasonList)
        }
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  const handleOnSaveClick = React.useCallback(async () => {
    if (formRef.current) {
      const { submitForm, validateForm, values } = formRef.current
      try {
        const errors = await validateForm(values)
        if (!isEmpty(errors)) {
          // call submit form , it will ask to validate all fields
          submitForm()
          // emit event to enable save button again
          eventEmitter.emit(constants.MODAL_FORM_SAVE_ERROR)
        } else {
          // form is valid
          try {
            await onSaveClick(values, action)
          } catch (error) {
            console.log(error)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }, [onSaveClick, action])

  const formElement = React.useMemo(() => {
    return (
      <Formik
        initialValues={formData}
        onSubmit={(values, { validate }) => {
          validate(values)
        }}
        innerRef={formRef}
        className={classes.root}
      >
        {({}) => {
          return (
            <Form>
              <FormControl className={classes.formControl} fullWidth>
                {action === cancelActionType ? (
                  <CancelForm
                    formData={formData}
                    reasons={reasons}
                    requireAlfredReason={requireAlfredReason}
                  />
                ) : null}
              </FormControl>
            </Form>
          )
        }}
      </Formik>
    )
  }, [classes, action, cancelActionType, formData, reasons, requireAlfredReason])

  return (
    <ModalForm
      isModalOpen={isModalOpen}
      onModalClose={closeModal}
      onSaveClick={handleOnSaveClick}
    >
      {formElement}
    </ModalForm>
  )
}

export default CancelModal
